import * as Sentry from "@sentry/solid";
import { createSignal, onCleanup } from "solid-js";

function createActionStatus({ timeout = 2000, resetOnError = true } = {}) {
  const [status, setStatus] = createSignal("idle");
  const [error, setError] = createSignal(null);

  let resetTimer;

  // Runs are numbered so a superseded one cannot report over a newer result,
  // and the pending reset is cleared so its timer cannot end a later run early.
  let runId = 0;

  const scheduleReset = () => {
    clearTimeout(resetTimer);

    resetTimer = setTimeout(() => setStatus("idle"), timeout);
  };

  onCleanup(() => clearTimeout(resetTimer));

  const run = async (fn) => {
    const id = ++runId;

    clearTimeout(resetTimer);

    setStatus("loading");
    setError(null);

    try {
      await fn();

      if (id !== runId) return;

      setStatus("success");

      scheduleReset();
    } catch (ex) {
      Sentry.captureException(ex);

      if (id !== runId) return;

      setError(ex);
      setStatus("error");

      if (resetOnError) scheduleReset();
    }
  };

  return [status, error, run];
}

export { createActionStatus };
